import { filter } from 'rxjs/operators';
import { homeRoute, loginRoute, changePasswordRoute, editProfileRoute, administrationRoute, exportConfigurationRoute,
         configurationsExpConfRoute, configurationTemplatesExpConfRoute, fieldAssignmentTemplatesExpConfRoute, emailTemplatesExpConfRoute,
         activationEmailTemplatesExpConfRoute, historyExpConfRoute, clientAdministrationRoute, userAdministrationRoute, productAssetsRoute,
         brandLogosRoute, assetsStorageRoute, assetsRoute, fieldValueReplacementsRoute, assetsStorageSettingsRoute,
         importConfigurationRoute, importConfigurationConfigurationRoute, importConfigurationProtocolRoute,
         emailSettingsRoute,
         settingsRoute,
         manualImportRoute,
         manualImportSalesOrdersRoute,
         manualImportSerialNumbersRoute,
         acodisWorkflowRoute,
         importConfigurationTemplateRoute,
         importConfigurationGlobalRoute,
         vendorScoreCardAdministrationRoute,
         vendorScoreCardVendorsRoute,
         vendorScoreCardRoute,
         assetsCollectionsRoute,
         manualImportVendorDeliveryDateRoute} from './../../core/routing/route-names';
import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserInfoDTO } from '../models/models.swagger.generated';
import { UserManagementComponent } from '../user-management/user-management.component';
import { Observable } from 'rxjs';
import { DropDownButtonModule, ItemModel } from '@syncfusion/ej2-angular-splitbuttons';
import { ModalService } from '../shared/modal/modal.service';
import { AccordionComponent, AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { ThemeService } from '../services/theme.service';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

interface RouteIdentifier {
  route: string,
  id: string
}

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [RouterLink, RouterLinkActive, LanguageSelectorComponent, AccordionModule, TranslateModule, DropDownButtonModule]
})
export class NavigationComponent implements OnInit {
  public loading = false;
  public userInfoModels: UserInfoDTO[] = [];
  public userInfoModels$: Observable<UserInfoDTO[]>;
  public userManagementComponent: UserManagementComponent;
  public activateVendorScoreCardFeature = environment.activateVendorScoreCardFeature;

  public homeRoute = homeRoute;
  public loginRoute = loginRoute;

  public clientAdministrationRoute = clientAdministrationRoute;
  public userAdministrationRoute = userAdministrationRoute;

  public configurationsExpConfRoute = configurationsExpConfRoute;
  public fieldValueReplacementsRoute = fieldValueReplacementsRoute;
  public configurationTemplatesExpConfRoute = configurationTemplatesExpConfRoute;
  public fieldAssignmentTemplatesExpConfRoute = fieldAssignmentTemplatesExpConfRoute;
  public emailTemplatesExpConfRoute = emailTemplatesExpConfRoute;
  public activationEmailTemplatesExpConfRoute = activationEmailTemplatesExpConfRoute;
  public historyExpConfRoute = historyExpConfRoute;

  public productAssetsRoute = productAssetsRoute;
  public brandLogosRoute = brandLogosRoute;
  public assetsStorageRoute = assetsStorageRoute;
  public assetCollectionsRoute = assetsCollectionsRoute;
  public assetsStorageSettingsRoute = assetsStorageSettingsRoute;

  public manualImportSalesOrdersRoute = manualImportSalesOrdersRoute;
  public manualImportVendorDeliveryDateRoute = manualImportVendorDeliveryDateRoute;
  public manualImportSerialNumbersRoute = manualImportSerialNumbersRoute;

  public importConfigurationConfigurationRoute = importConfigurationConfigurationRoute;
  public importConfigurationProtocolRoute = importConfigurationProtocolRoute;
  public importConfigurationTemplateRoute = importConfigurationTemplateRoute;
  public importConfigurationGlobalRoute = importConfigurationGlobalRoute;

  public emailSettingsRoute = emailSettingsRoute;

  public acodisWorkflowRoute = acodisWorkflowRoute;

  public vendorScoreCardAdministrationRoute = vendorScoreCardAdministrationRoute;
  public vendorScoreCardVendorsRoute = vendorScoreCardVendorsRoute;

  public adminSectionId = 'admin-section';
  public exportConfigurationSectionId = 'export-configuration';
  public assetsSectionId = 'assets';
  public manualImportSectionId = 'manual-import';
  public importConfigurationSectionId = 'import-configuration';
  public settingsSectionId = 'settings';
  public vendorScoreCardSectionId = 'vendor-score-card';

  private subrouteMatch: RouteIdentifier = null;

  @ViewChild(AccordionComponent) public accordion: AccordionComponent;

  public userIcon = 'icon-user';
  public userNavigation: ItemModel[] = [];

  private isAccordionInitialized = false;


  constructor(
    private router: Router,
    private modalService: ModalService,
    private translate: TranslateService,
    public authService: AuthService,
    private msalAuthService: MsalService,
    private themeService: ThemeService) {
  }

  public ngOnInit(): void {
    this.translate.onLangChange.subscribe(_ => {
      this.userNavigation = [
        {text: this.translate.instant('i18n.core.navigation.editProfile'), id: 'editProfile',  iconCss: 'icon-user--profile'},
        {text: this.translate.instant('i18n.core.navigation.changePassword'), id: 'changePassword', iconCss: 'icon-password'},
        {text: this.translate.instant('i18n.core.navigation.toggleTheme'), id: 'toggleTheme', iconCss: 'icon-color-switch'},
        {text: this.translate.instant('i18n.core.navigation.logout'), id: 'logout', iconCss: 'icon-logout'},
      ];
      if(this.authService.isUserDomainUser()) {
        this.userNavigation = this.userNavigation.filter(item => item.id !== 'editProfile' && item.id !== 'changePassword');
      }
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
      const subroutes: RouteIdentifier[] = [
        {route: vendorScoreCardRoute + '/', id: this.vendorScoreCardSectionId}, // keep this route before adminsistration route to work properly
        {route: administrationRoute + '/', id: this.adminSectionId},
        {route: exportConfigurationRoute + '/', id: this.exportConfigurationSectionId},
        {route: assetsRoute + '/', id: this.assetsSectionId},
        {route: importConfigurationRoute + '/', id: this.importConfigurationSectionId},
        {route: manualImportRoute + '/', id: this.manualImportSectionId}, // keep manual import route after import configuration route for proper matching of manual-import tab in import config
        {route: settingsRoute + '/', id: this.settingsSectionId}
      ];
      const url = this.router.url + '/';
      this.subrouteMatch = subroutes.find(s => url?.toLocaleLowerCase().indexOf(s.route) > -1);

      if (this.isAccordionInitialized) {
        this.expandAccordionSection(this.subrouteMatch?.id);
      }
    });
  }

  public onSelection(event: any): void {
    switch(event.item.id) {
      case 'editProfile':
        this.editUser();
        break;
      case 'changePassword':
        this.changePassord();
        break;
      case 'toggleTheme':
        this.themeService.toggleTheme();
        break;
      case 'logout':
        this.logout();
        break;
    }
  }

  public editUser() {
    this.router.navigate([editProfileRoute]);
  }

  public logout() {
    const dialog = this.modalService.showOkCancelDialog('i18n.core.modal.logout.title', 'i18n.core.modal.logout.question');
    dialog.onOkSubject.subscribe(() => {
      this.authService.logout();
    });
  }

  public changePassord() {
    this.router.navigate([changePasswordRoute]);
  }

  public onAccordionCreated() {
    this.isAccordionInitialized = true;
    if (this.subrouteMatch) {
      this.expandAccordionSection(this.subrouteMatch.id);
    }
  }

  // expand or collapse
  private expandAccordionSection(htmlElementId: string) {
    if (!this.accordion) {
      return;
    }
    for(let i = 0; i < this.accordion.element.children.length; i++) {
      const item = this.accordion.element.children.item(i);
      if (item.id == htmlElementId) {
        this.accordion.expandItem(true, i);
      } else {
        this.accordion.expandItem(false, i);
      }
    }
  }
}
